import axios from "axios";
import React, { useState } from "react";
import { baseUrl } from "../config";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button } from "./styles";

const UserRegister = () => {
  const [formData, setFormData] = useState({
    pseudo: "",
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(baseUrl + "/register", formData);
      setMessage("Utilisateur créé avec succès !");
      setError(null);
      setSuccess(true);
    } catch (error) {
      if (error.response) {
        // Erreurs retournées par le serveur
        if (error.response.status === 409) {
          if (error.response.data.error.includes("Pseudo")) {
            setError("Pseudo déjà utilisé.");
          } else if (error.response.data.error.includes("Email")) {
            setError("Email déjà utilisé.");
          } else {
            setError("Pseudo ou email déjà utilisé.");
          }
        } else if (error.response.status === 400) {
          if (error.response.data.error.includes("sécurisé")) {
            setError("Le mot de passe est trop faible.");
          } else {
            setError("Tous les champs sont requis.");
          }
        } else {
          setError("Erreur lors de la création de l'utilisateur.");
        }
      } else {
        // Autres erreurs (réseau, etc.)
        setError("Erreur réseau. Veuillez réessayer plus tard.");
      }
    }
  };

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <FormContainer>
      <h2>Créer un compte</h2>
      {success ? (
        <div>
          <SuccessText>{message}</SuccessText>
          <Button type="button" onClick={handleLoginRedirect}>
            Aller à la page de connexion
          </Button>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <label>
            Pseudo:
            <input
              type="text"
              name="pseudo"
              value={formData.pseudo}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Mot de passe:
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </label>
          <Button type="submit">Créer un compte</Button>
        </form>
      )}
      {error && <ErrorText>{error}</ErrorText>}
    </FormContainer>
  );
};

const FormContainer = styled.div`
  width: min(100%, 560px);
  margin: 0 auto;
  margin-top: var(--space-8);
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-2);

  h2 {
    margin-bottom: 20px;
  }

  label {
    display: block;
    margin-bottom: 10px;

    input {
      width: 100%;
      padding: 8px;
      margin-top: 5px;
      border: 1px solid var(--border);
      border-radius: var(--radius-sm);
      background: transparent;
      color: var(--text);
    }
  }

  button {
    margin-top: 20px;
  }

  p {
    margin-top: 10px;
  }
`;

const SuccessText = styled.p`
  margin-top: 10px;
  color: green;
`;

const ErrorText = styled.p`
  margin-top: 10px;
  color: red;
`;

export default UserRegister;
